import * as api from '../../../clients/veranstaltungen';

import {Action} from '@ngrx/store';

export const POST_FUNKPROTOKOLL_FALL_BILD_HINZUFUEGEN = '[VeranstaltungenModul] PostFunkprotokollFallBildHinzufuegen laden';
export const POST_FUNKPROTOKOLL_FALL_BILD_HINZUFUEGEN_AUSFUEHREN = '[VeranstaltungenModul] PostFunkprotokollFallBildHinzufuegen ausführen';
export const POST_FUNKPROTOKOLL_FALL_BILD_HINZUFUEGEN_ERFOLGREICH = '[VeranstaltungenModul] PostFunkprotokollFallBildHinzufuegen laden erfolgreich';
export const POST_FUNKPROTOKOLL_FALL_BILD_HINZUFUEGEN_FEHLER = '[VeranstaltungenModul] PostFunkprotokollFallBildHinzufuegen Ladefehler';
export const POST_FUNKPROTOKOLL_FALL_BILD_HINZUFUEGEN_NICHT_AUSGEFUEHRT = '[VeranstaltungenModul] PostFunkprotokollFallBildHinzufuegen nicht ausgeführt (evtl. Offline)';


export class PostFunkprotokollFallBildHinzufuegenAction implements Action {
    readonly type = POST_FUNKPROTOKOLL_FALL_BILD_HINZUFUEGEN;
        constructor(public funkprotokollFallBildRequest: api.FunkprotokollFallBildRequest, public optPayload: any = null) {}
    }
export class PostFunkprotokollFallBildHinzufuegenAusfuehrenAction implements Action {
    readonly type = POST_FUNKPROTOKOLL_FALL_BILD_HINZUFUEGEN_AUSFUEHREN;
        constructor(public funkprotokollFallBildRequest: api.FunkprotokollFallBildRequest, public optPayload: any = null) {}
    }
export class PostFunkprotokollFallBildHinzufuegenErfolgreichAction implements Action {
    readonly type = POST_FUNKPROTOKOLL_FALL_BILD_HINZUFUEGEN_ERFOLGREICH;
        constructor(public payload: api.FunkprotokollIdentifier, public funkprotokollFallBildRequest: api.FunkprotokollFallBildRequest, public optPayload: any = null) {}
    }
export class PostFunkprotokollFallBildHinzufuegenFehlerAction implements Action {
    readonly type = POST_FUNKPROTOKOLL_FALL_BILD_HINZUFUEGEN_FEHLER;
        constructor(public payload: any, public funkprotokollFallBildRequest: api.FunkprotokollFallBildRequest, public optPayload: any = null) {}
    }
export class PostFunkprotokollFallBildHinzufuegenNichtAusgefuehrtAction implements Action {
    readonly type = POST_FUNKPROTOKOLL_FALL_BILD_HINZUFUEGEN_NICHT_AUSGEFUEHRT;
        constructor(public optPayload: any = null) {}
    }
    

export type VeranstaltungenCommandFunkprotokollFallBildHinzufuegenActions =
    PostFunkprotokollFallBildHinzufuegenAction
    | PostFunkprotokollFallBildHinzufuegenAusfuehrenAction
    | PostFunkprotokollFallBildHinzufuegenErfolgreichAction
    | PostFunkprotokollFallBildHinzufuegenFehlerAction
    | PostFunkprotokollFallBildHinzufuegenNichtAusgefuehrtAction
    ;
